// REFACTORED: 2026-02-03
// Projects page error state - Error display with retry action

import React from 'react';
import { Box, Alert } from '@mui/material';

interface ProjectsErrorStateProps {
  onRetry: () => void;
}

/**
 * ProjectsErrorState Component
 * 
 * Displays error message when projects data fails to load
 * Provides a retry button to attempt reloading the data
 */
const ProjectsErrorState: React.FC<ProjectsErrorStateProps> = ({ onRetry }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Alert
        severity="error"
        sx={{ mb: 2 }}
        action={
          <Box
            component="button"
            onClick={onRetry}
            sx={{
              background: "none",
              border: "none",
              color: "inherit",
              cursor: "pointer",
              textDecoration: "underline",
              fontSize: "0.875rem",
            }}
          >
            Retry
          </Box>
        }
      >
        Error loading projects data. Please try again.
      </Alert>
    </Box>
  );
};

export default ProjectsErrorState;

